import * as React from "react";

const IconTwitter: React.FC<React.SVGAttributes<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      stroke="#3C773B"
      {...props}
    >
      <circle cx="16" cy="16" r="15.5" />
      <path
        d="M25 9.00785C24.2165 9.53487 23.349 9.93795 22.4309 10.2016C21.9382 9.66129 21.2833 9.27834 20.5548 9.10454C19.8264 8.93073 19.0596 8.97445 18.3581 9.22978C17.6565 9.48511 17.0542 9.93974 16.6324 10.5322C16.2107 11.1246 15.9899 11.8263 16 12.5422V13.3225C14.5622 13.358 13.1374 13.0539 11.8526 12.4373C10.5679 11.8206 8.63636 9.78806 8.63636 9.78806C8.63636 9.78806 5.36364 16.81 12.7273 19.9309C11.0422 21.0216 9.03495 21.5685 7 21.4913C14.3636 25.3924 23.3636 21.4913 23.3636 12.5188C23.3629 12.3015 23.341 12.0847 23.2982 11.8712C24.1332 11.086 24.7225 10.0945 25 9.00785Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export { IconTwitter };
